import React, { useState } from 'react';
import useStores from '../../hooks/useStores';
import Alert, { Type } from '../Alert';
import Translate from '../Translate/Translate';
import { getGaId } from '../../services/Analytics';

import './styles/CheckoutPaymentBtn.scss';
import Checkbox from '../Forms/Input/Checkbox';

const CheckoutPaymentBtn = () => {
  const { checkout, orders, payment, cart, authentication } = useStores();
  const [errorMessage, setErrorMessage] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);
  const [registerNewsletter, setRegisterNewsletter] = useState(false);

  const isAuthenticated = authentication?.loggedIn || false;

  const onTermsButtonClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setTermsAccepted(checked);
    checkout.setValue('termsAgreement', checked);
    checkout.validateValue('termsAgreement', checked);

    if (checked) {
      setShowTermsError(false);
    }
  };

  const testValidation = () => {
    setShowTermsError(!termsAccepted);
    checkout.validateAllFields();
  };

  const onNewsletterButtonClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRegisterNewsletter(e.target.checked);
  };

  async function onPayButtonClick() {
    const clientId = await getGaId();

    try {
      checkout.loading = !checkout.loading;
      const order = await orders.create({
        firstname: checkout.firstname,
        lastname: checkout.lastname,
        email: checkout.email,
        phone: checkout.phone,
        shipping: checkout.shippingMethod,
        shipping_option: checkout.shippingOption,
        shipping_country: checkout.shippingCountry,
        shipping_city: checkout.shippingCity,
        shipping_address: checkout.shippingAddress,
        shipping_zip: checkout.shippingZip,
        payment_method: checkout.paymentMethod,
        client_id: clientId,
        newsletter: !isAuthenticated && registerNewsletter,
      });

      const { reference } = order;

      // For card payments special checkout form must be initialized
      const paymentMethod = checkout.getPaymentMethod(checkout.paymentMethod);
      if (paymentMethod) {
        if (paymentMethod.processor === 'montonio') {
          window.location.href = (
            await payment.montonioTransaction(reference, paymentMethod.code)
          ).url;

          return;
        }
      }

      let url;

      if (
        checkout.paymentMethod === 'inbank-split-3' ||
        checkout.paymentMethod === 'inbank-split-6' ||
        checkout.paymentMethod === 'inbank-next-month'
      ) {
        url = (await payment.inbank(reference, checkout.paymentMethod)).url;
      } else if (checkout.paymentMethod === 'modena') {
        url = (await payment.modena(reference)).url;
      } else {
        url = (await payment.transaction(reference, checkout.paymentMethod))
          .url;
      }

      window.location.href = url;
    } catch (error: unknown) {
      const err = error as any;
      if (err?.response?.status === 404) {
        setErrorMessage(true);
      } else {
        setErrorMessage(false);
      }
    }
  }

  return (
    <>
      <Alert show={!!errorMessage} type={Type.ERROR}>
        <Translate component="checkout" keyword="required-fields" />
      </Alert>
      <div className="my-5">
        <Checkbox
          id="terms"
          label="Nõustun"
          linkText="kasutustingimustega*"
          linkHref="/tingimused"
          checked={termsAccepted}
          onChange={onTermsButtonClick}
          required
          iconSize="size-6"
          checkboxSize="size-8"
          textSize="text-md"
        />
      </div>
      {!isAuthenticated && (
        <div className="my-5">
          <Checkbox
            id="newsletter"
            label="Liitun uudiskirjaga"
            checked={registerNewsletter}
            onChange={onNewsletterButtonClick}
            iconSize="size-6"
            checkboxSize="size-8"
            textSize="text-md"
          />
        </div>
      )}

      <Alert show={showTermsError} type={Type.ERROR}>
        <Translate component="checkout" keyword="checkout-terms" />
      </Alert>

      <button
        className={`component-checkoutPaymentBtn${
          checkout.paymentMethod &&
          checkout.isCheckoutReady &&
          cart.variations.length
            ? ''
            : '--disabled'
        }`}
        onClick={
          checkout.paymentMethod &&
          checkout.isCheckoutReady &&
          cart.variations.length
            ? onPayButtonClick
            : testValidation
        }
      >
        {checkout.paymentMethod === 'inbank-split-3' ||
        checkout.paymentMethod === 'inbank-split-6' ||
        checkout.paymentMethod === 'inbank-next-month' ||
        checkout.paymentMethod === 'modena' ? (
          <p>
            <Translate component="user-orders" keyword="make-order" />
          </p>
        ) : (
          <p>
            <Translate component="checkout" keyword="button" />
          </p>
        )}
      </button>
    </>
  );
};

export default CheckoutPaymentBtn;
